module.exports = __webpack_public_path__ + "img/question-set-form.03734e3f.png";